import type { PaymentMethod } from 'src/content/management/Events/components/PaymentMethodIcon';
import type { PaymentMethodFilterValue } from 'src/components/Filters/FilterContainerPaymentMethod';
import type { PaymentMethodBucket } from 'src/models/statistic';

const KNOWN_PAYMENT_METHODS = ['qr', 'cash', 'payment_link'] as const;

export function isKnownPaymentMethod(
  method: PaymentMethod | null | undefined,
): method is 'qr' | 'cash' | 'payment_link' {
  return (KNOWN_PAYMENT_METHODS as readonly string[]).includes(method ?? '');
}

/** null, 'other' o valor no mapeado → bucket other (alineado con stats backend). */
export function isOtherPaymentMethodBucket(
  method: PaymentMethod | null | undefined,
): boolean {
  return !isKnownPaymentMethod(method);
}

export function matchesPaymentMethodFilter(
  method: PaymentMethod | null | undefined,
  filter: PaymentMethodFilterValue,
): boolean {
  const anyFilterActive =
    filter.qr || filter.cash || filter.payment_link || filter.other;

  if (!anyFilterActive) return true;
  if (method === 'qr') return filter.qr;
  if (method === 'cash') return filter.cash;
  if (method === 'payment_link') return filter.payment_link;
  return filter.other;
}

export function shouldIncludeOtherPaymentMethodInFilter(
  method: PaymentMethod | null | undefined,
  filter: PaymentMethodFilterValue,
): boolean {
  return isOtherPaymentMethodBucket(method) && filter.other;
}

/** Columna Método de pago: con filtro activo en tabla, solo ese bucket. */
export function getPaymentMethodsForTableRow(
  paymentMethods: PaymentMethodBucket[] | undefined,
  activeMethod: PaymentMethodBucket | '' | null | undefined,
): PaymentMethodBucket[] {
  if (activeMethod) return [activeMethod];
  return paymentMethods ?? [];
}

/** Subtítulo de tickets en fila evento: cantidad del método filtrado si aplica. */
export function getPaymentMethodRowTicketQt(
  totalQt: number,
  byMethod: Record<PaymentMethodBucket, { qt: number }> | undefined,
  activeMethod: PaymentMethodBucket | '' | null | undefined,
): number {
  if (activeMethod && byMethod?.[activeMethod] != null) {
    return byMethod[activeMethod].qt;
  }
  return totalQt;
}

export function buildExclusivePaymentMethodFilter(
  method: PaymentMethodBucket,
): PaymentMethodFilterValue {
  return {
    qr: method === 'qr',
    cash: method === 'cash',
    payment_link: method === 'payment_link',
    other: method === 'other',
  };
}
